import { Link } from "react-router-dom";
import { useSite, usePageMeta } from "@/hooks/useSite";
import { SiteLayout } from "@/components/SiteLayout";

export default function NotFound() {
  usePageMeta({
    title: "Page not found – Nepal Food Networks",
    description: "This page could not be found.",
    robots: "noindex, follow",
  });
  const { data } = useSite();
  const body = (
    <section className="section" data-testid="not-found-page">
      <div className="wrap">
        <h1>Page not found</h1>
        <p className="lede">The page you are looking for does not exist or has moved.</p>
        <div className="actions">
          <Link className="btn" to="/" data-testid="not-found-home-link">Back to Home</Link>
        </div>
      </div>
    </section>
  );
  return data ? <SiteLayout data={data} current="404">{body}</SiteLayout> : <main>{body}</main>;
}
